import {
  FormControl,
  FormControlLabel,
  type FormControlProps,
  FormHelperText,
} from '@mui/material';
import { Translate, type Translation } from '@shared/translation';
import type { ReactNode } from 'react';
import { Checkbox, type CheckboxProps } from './Checkbox';
import { FieldLabel } from './FieldLabel';

export interface CheckboxFieldProps extends CheckboxProps {
  label?: Translation | ReactNode;
  helperText?: ReactNode;
  error?: boolean;
  controlProps?: FormControlProps;
  requiredLabel?: Translation;
  showRequiredLabel?: boolean;
}

export const CheckboxField = ({
  label,
  helperText,
  error,
  controlProps,
  requiredLabel,
  showRequiredLabel,
  ...props
}: CheckboxFieldProps) => {
  return (
    <FormControl error={error} {...controlProps}>
      <FormControlLabel
        label={
          isTranslation(label) ? (
            <FieldLabel
              label={label}
              required={showRequiredLabel}
              requiredLabel={requiredLabel}
            />
          ) : (
            label
          )
        }
        control={<Checkbox {...props} />}
      />
      {helperText && (
        <FormHelperText>
          {isTranslation(helperText) ? (
            <Translate text={helperText} />
          ) : (
            helperText
          )}
        </FormHelperText>
      )}
    </FormControl>
  );
};

function isTranslation(value: unknown): value is Translation {
  return (
    value === null ||
    value === undefined ||
    typeof value === 'string' ||
    (typeof value === 'object' && 'message' in value)
  );
}
